import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework";
const SupportAtlassianCommunity = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.supportAtlassianCommunity.content.body"
                    defaultMessage="Get support from the <a>Atlassian Community</a>, a public forum of community experts where you can ask questions. You can also access free Confluence guides and knowledge base articles."
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-track-event="ConfluencePricingPageTeam24.supportAtlassianCommunity"
                                data-event-container="ConfluencePriceFinderTeam24"
                                data-label-english="Atlassian Community"
                                href="https://community.atlassian.com/"
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
export default SupportAtlassianCommunity;
